var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", [
      _c(
        "div",
        {
          staticClass: "extraBox store text-center cursor",
          on: {
            click: function($event) {
              return _vm.showModal()
            }
          }
        },
        [
          _vm.loading
            ? [
                _c("i", {
                  staticClass: "fa fa-spin fa-circle-o-notch mb-3 mt-1",
                  attrs: { "aria-hidden": "true" }
                })
              ]
            : [
                _c("i", {
                  staticClass: "fa fa-home mb-3 mt-1",
                  attrs: { "aria-hidden": "true" }
                })
              ],
          _vm._v(" "),
          _c("div", {
            domProps: {
              innerHTML: _vm._s(_vm.$translate("Bigtex5::Template.storeButton"))
            }
          })
        ],
        2
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "stocks",
        staticClass: "modal fade stocks",
        attrs: { tabindex: "-1", role: "dialog" }
      },
      [
        _c(
          "div",
          { staticClass: "modal-dialog", staticStyle: { top: "50px" } },
          [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c("h3", { staticClass: "modal-title" }, [
                  _vm._v(
                    _vm._s(_vm.$translate("Bigtex5::Template.storeHeadline"))
                  )
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "close",
                    attrs: {
                      type: "button",
                      "data-dismiss": "modal",
                      "aria-label": _vm.$translate("Ceres::Template.closeIcon")
                    }
                  },
                  [
                    _c("span", { attrs: { "aria-hidden": "true" } }, [
                      _vm._v("×")
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "modal-body" },
                [
                  _vm.variations.length > 0
                    ? [
                        _c("table", { staticClass: "table table-striped" }, [
                          _c(
                            "tbody",
                            _vm._l(_vm.variations, function(variation, index) {
                              return variation.stock.length > 0
                                ? _c("tr", { key: index }, [
                                    _c("td", { staticClass: "w-50" }, [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(variation.attrValues[0].name) +
                                          "\n                              "
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "w-50 text-right" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "text-green" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$translate(
                                                  "Bigtex5::Template.storeavailable"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e()
                            }),
                            0
                          )
                        ])
                      ]
                    : [
                        _c(
                          "div",
                          {
                            staticClass: "p-3 text-center",
                            staticStyle: { "background-color": "#f0f0f0" }
                          },
                          [
                            _vm._v(
                              "\n                          " +
                                _vm._s(
                                  _vm.$translate(
                                    "Bigtex5::Template.storenotavailable"
                                  )
                                ) +
                                "\n                        "
                            )
                          ]
                        )
                      ]
                ],
                2
              )
            ])
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }